package com.arena_web.data.dto

import kotlinx.serialization.Serializable

/**
 * The user's Access subscription state. `status == null` means the user has
 * never subscribed; `active` is the single flag the UI gates premium actions on.
 */
@Serializable
data class SubscriptionDto(
    /** Provider status string (e.g. "active", "canceled"); null = never subscribed. */
    val status: String? = null,
    val active: Boolean = false,
    /** ISO timestamp of the current period end, if any. */
    val currentPeriodEnd: String? = null,
    val cancelAtPeriodEnd: Boolean = false,
    val provider: String? = null,
    /** The 3-day trial can be started — true only for never-subscribed users. */
    val trialAvailable: Boolean = false,
    /** The current period is the trial window. */
    val isTrial: Boolean = false,
)

/**
 * Web checkout: redirect the browser to [pageUrl] (mono's hosted payment page);
 * mono sends the user back afterwards and the order is confirmed by reference.
 */
@Serializable
data class SubscriptionCheckoutDto(
    val orderReference: String,
    /** mono invoice id. */
    val invoiceId: String,
    /** mono hosted payment page to redirect the browser to. */
    val pageUrl: String,
    val amount: String,
    val currency: String,
)

@Serializable
data class SubscriptionConfirmRequest(
    /** Order reference returned by the checkout endpoint. */
    val orderReference: String,
)

@Serializable
data class SubscriptionCheckoutRequest(
    /** Analytics source label that opened the paywall (e.g. "profile", "event_gate"). */
    val source: String? = null,
    /** Start the 3-day trial checkout instead of the full-price one. */
    val trial: Boolean = false,
)
